import {createContext} from 'react';

export const AuthContext = createContext({
    authenticated: false,
    role: '',
    businessId: '',
    userEmail:'',
    login: () => {},
    logout: () => {}
});